import i18n from "i18next";

import translationEN from './locales/en.json';
import translationES from './locales/es.json';
import translationCR from './locales/es-cr.json';

const getCookieData = name => {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) return match[2];
}

i18n.init({
    resources: {
        en: {
            translations: translationEN
        },
        es: {
            translations: translationES
        },
        "es-CR": {
            translations: translationCR
        }
    },
    lng: getCookieData('locale') || 'en',
    fallbackLng: "es",
    debug: true,
    returnEmptyString: false,
    ns: ["translations"],
    defaultNS: "translations",

    keySeparator: false,

    interpolation: {
        escapeValue: false,
        formatSeparator: ","
    }

}, function () {
    window.Parsley.setLocale(getCookieData('locale') || 'en')
});

export default i18n;